/**
 * Liminal Reverb — sample × room audio matrix (marketing previews).
 *
 * Pattern: pick ONE sample + ONE room at a time. Each cell is a baked preview
 * (that demo track rendered through that room). The browser just plays the
 * file — no convolution.
 *
 * ── How to register files ──────────────────────────────────────────────
 * Put WAV files in theme `assets/` (Shopify has no asset subfolders).
 *
 *  WET  sampleId × roomId → set `audio` on room.samples[] entry:
 *       sample-1 × rainbow    → liminal-rainbow-sample-01.wav
 *       sample-5 × poolrooms  → liminal-poolrooms-sample-05.wav
 *
 *  DRY  sampleId → set `dry` on the sample (unprocessed source, no room):
 *       sample-1 → liminal-dry-sample-01.wav
 *
 * Leave null until the file exists — null is never requested.
 *
 *  `label` is the full name shown in the readout; `short` is the 3-letter
 *  channel key on the console. Both are PLACEHOLDERS until final tracks land.
 *
 * Rooms align with the plugin: Rainbow Door · Hills · Corridor · Backrooms · Poolrooms
 */
window.LR_ROOM_DEMOS = {
  samples: [
    { id: "sample-1", label: "Guitar", short: "GTR", dry: "liminal-dry-sample-01.wav?v=gtr2" },
    { id: "sample-2", label: "Synth", short: "SYN", dry: "liminal-dry-sample-02.wav?v=syn2" },
    { id: "sample-5", label: "Full Mix", short: "MIX", dry: "liminal-dry-sample-05.wav?v=mix1" }
  ],

  rooms: [
    {
      id: "rainbow",
      name: "Rainbow Door",
      artwork: "liminal-slide-arcade.png",
      artworkAlt: "liminal-slide-arcade-face.png",
      samples: [
        { id: "sample-1", audio: "liminal-rainbow-sample-01.wav?v=gtr2" },
        { id: "sample-2", audio: "liminal-rainbow-sample-02.wav?v=syn2" },
        { id: "sample-5", audio: "liminal-wet-sample-05.wav?v=mix1" }
      ]
    },
    {
      id: "hills",
      name: "Hills",
      artwork: "liminal-slide-hills.png",
      artworkAlt: "liminal-slide-hills-open.png",
      samples: [
        { id: "sample-1", audio: "liminal-hills-sample-01.wav?v=gtr2" },
        { id: "sample-2", audio: "liminal-hills-sample-02.wav?v=syn2" },
        { id: "sample-5", audio: "liminal-wet-sample-05.wav?v=mix1" }
      ]
    },
    {
      id: "corridor",
      name: "Corridor",
      artwork: "liminal-slide-exit.png",
      artworkAlt: "liminal-slide-exit-alt.png",
      samples: [
        { id: "sample-1", audio: "liminal-corridor-sample-01.wav?v=gtr2" },
        { id: "sample-2", audio: "liminal-corridor-sample-02.wav?v=syn2" },
        { id: "sample-5", audio: "liminal-wet-sample-05.wav?v=mix1" }
      ]
    },
    {
      id: "backrooms",
      name: "Backrooms",
      artwork: "liminal-slide-room.png",
      artworkAlt: "liminal-slide-room-beam.png",
      samples: [
        { id: "sample-1", audio: "liminal-backrooms-sample-01.wav?v=gtr2" },
        { id: "sample-2", audio: "liminal-backrooms-sample-02.wav?v=syn2" },
        { id: "sample-5", audio: "liminal-wet-sample-05.wav?v=mix1" }
      ]
    },
    {
      id: "poolrooms",
      name: "Poolrooms",
      artwork: "liminal-slide-pool.jpg",
      artworkAlt: "liminal-slide-pool-q.jpg",
      samples: [
        { id: "sample-1", audio: "liminal-poolrooms-sample-01.wav?v=gtr2" },
        { id: "sample-2", audio: "liminal-poolrooms-sample-02.wav?v=syn2" },
        { id: "sample-5", audio: "liminal-wet-sample-05.wav?v=mix1" }
      ]
    }
  ]
};
